import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NewsService } from '../../core/services/news.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  editionNumber$: Observable<number>;

  constructor(private newsService: NewsService) {
    // Edition number is simply the total count of published news
    this.editionNumber$ = this.newsService.getTotalNewsCount();
  }

  ngOnInit(): void {}
}
